const INITIAL_STATE = {
  pageNo: 1,
  customerListing: []
};

export default function customerList(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'customers') {
        const url_string = new URL(payload.response.config.url && payload.response.config.url);

        const pageNo = url_string.searchParams.get("pageNo");
        return {
          pageNo: pageNo,
          customerListing: [
          ...state.customerListing,
          ...payload.response.data
        ]
        };
      }
      return state;
    }

    case 'clearCustomerList': {
      // console.log('INITIAL_STATE2', state);
        return INITIAL_STATE;
      }
      
    default:
      return state;
  }
}
